import { Box, Heading, Image, Text } from '@doist/marketist'

import { useTranslation } from 'next-i18next'

import css from './author.module.css'

import type { Article } from '@doist/help-center-utils'

export function Author({ user, updatedAt }: { user: Article['user']; updatedAt: string | null }) {
    const { t } = useTranslation('helpcenter')
    const dateOptions = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    } as const

    return user ? (
        <Box data-nosnippet>
            <Heading level="3" size="minor-base" weight="semibold" className="mbe-8">
                {t('article.lastUpdatedBy')}
            </Heading>
            <Box className={css.author}>
                <Image src={user.photo.content_url} width={36} height={36} className={css.avatar} />
                <Box>
                    <Text size="body-xs">{user.name}</Text>
                    {updatedAt ? (
                        <Text
                            size="body-2xs"
                            className={css.secondary}
                            weight="medium"
                            suppressHydrationWarning
                        >
                            {new Date(updatedAt).toLocaleDateString(undefined, dateOptions)}
                        </Text>
                    ) : null}
                </Box>
            </Box>
        </Box>
    ) : null
}
